import { FieldInputProps, FieldMetaProps, FieldHelperProps } from 'formik';

export interface AtomProps<T extends any = any> {
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  helpText?: string;
  infoText?: string;
  label?: string;
  dataTest: string;
  error?: string;
  value: T | undefined;
  onChange(value: T | undefined): void;
  onBlur?(value: T | undefined): void;
}

export const errorValue = (error?: { value: string } | string) =>
  (error as any)?.value ? (error as any).value : error;

export type FormikField<Value> = [FieldInputProps<Value>, FieldMetaProps<Value>, FieldHelperProps<Value>];
